import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turn_left"}/>
}
